import React from 'react';

export type BadgeDisplayProps = React.HTMLAttributes<HTMLDivElement> & {
  children: React.ReactNode | React.ReactNode[];
  /**
   * @deprecated this prop is no longer needed.
   */
  theme?: 'dark' | 'light';
};

export const BadgeDisplay: React.FC<BadgeDisplayProps> = ({
  children,
  // theme = 'dark',
  className,
  style,
  ...props
}) => {
  return (
    <div
      {...props}
      style={{
        borderRadius: 5,
        fontSize: 12,
        // backgroundColor: colors.themes[theme].badgeBackground,
        maxWidth: '250px',
        ...(style ?? {}),
      }}
      className={
        'm-1 p-1 text-center fw-bold badge-background ' + (className ?? '')
      }
    >
      {children}
    </div>
  );
};
